import React from 'react';
import { FaCalendarAlt, FaLightbulb, FaUsers } from 'react-icons/fa';
import { renderSchedule } from '../../utils/holidayUtils';
import {
  isProspectiveShabbaton,
  isRegistrationInScheduleGrid,
  isRegistrationVisible,
  isSideBySideRegistration,
} from '../../utils/holidayRegistration';
import RichText from './RichText';
import RegistrationSection from './RegistrationSection';
import '../../css/events/Holidays.css';

const HolidayModal = ({ holiday, onClose }) => {
  const sideBySide = holiday ? isSideBySideRegistration(holiday) : false;
  const showExternalRegistration =
    holiday && isRegistrationVisible(holiday) && !isRegistrationInScheduleGrid(holiday);

  if (!holiday) return null;

  const shabbaton = isProspectiveShabbaton(holiday);

  return (
    <div className="holiday-modal-overlay" onClick={onClose}>
      <div className="holiday-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="holiday-modal-close" onClick={onClose}>×</button>
        <div className="holiday-modal-header">
          <div
            className="holiday-modal-icon"
            style={{ '--holiday-bg-color': holiday.backgroundColor }}
          >
            {holiday.icon}
          </div>
          <div className="holiday-modal-info">
            <h2 className="holiday-modal-name">{holiday.name}</h2>
            <RichText value={holiday.description} className="holiday-modal-description" />
            <div className="holiday-dates">
              <FaCalendarAlt />
              <span>{holiday.generalDates}</span>
            </div>
            {!shabbaton && holiday.when && holiday.when !== holiday.generalDates && (
              <div className="holiday-dates">
                <FaCalendarAlt />
                <span>{holiday.when}</span>
              </div>
            )}
            {!shabbaton && holiday.whenSubtext && (
              <RichText value={holiday.whenSubtext} className="holiday-modal-subtext" />
            )}
            {!shabbaton && holiday.whoCanAttend && (
              <div className="holiday-who">
                <FaUsers />
                <span>{holiday.whoCanAttend}</span>
              </div>
            )}
            {!shabbaton && holiday.whoSubtext && (
              <RichText value={holiday.whoSubtext} className="holiday-modal-subtext" />
            )}
            {holiday.candleLighting && holiday.candleLighting !== 'N/A' && (
              <div className="holiday-candle-lighting">
                <FaLightbulb />
                <span>Candle Lighting: {holiday.candleLighting}</span>
              </div>
            )}
          </div>
        </div>
        <div className="holiday-modal-body">
          <div className="holiday-details">
            <RichText value={holiday.details} className="holiday-details-text" />
          </div>
          <div className={`holiday-schedule-registration ${sideBySide ? 'is-side-by-side' : ''}`}>
            <div className="holiday-schedule">
              <h3>Schedule</h3>
              {renderSchedule(holiday)}
            </div>
            {showExternalRegistration && (
              <RegistrationSection registration={holiday.registration} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HolidayModal;
